import Cookies from 'universal-cookie';

export default class UtmHelper {
    
    parseUtmCookie = ( cookie ) => {
        var values = {};
        if (cookie) {
            var z = cookie.split('.');
            if (z.length >= 4) {
                var y = z[4].split('|');
                for (var j = 0; j < y.length; j++) {
                    var pair = y[j].split("=");
                    values[pair[0]] = pair[1];
                }
            }
        }
        return values;
    }

    parseURL = () => {
        var url = window.location.href;
        var parser = document.createElement('a'),
            searchObject = {},
            queries, split, i;
        // Let the browser do the work
        parser.href = url;
        // Convert query string to object
        queries = parser.search.replace(/^\?/, '').split('&');
        for(var i = 0; i < queries.length; i++ ) {
            split = queries[i].split('=');
            searchObject[split[0]] = split[1];
        }
        return {
            protocol: parser.protocol,
            host: parser.host,
            hostname: parser.hostname,
            port: parser.port,
            pathname: parser.pathname,
            search: parser.search,
            searchObject: searchObject,
            hash: parser.hash
        };
    }

    getUtmParameters = () => {

        var parsed = this.parseURL();
        const cookies = new Cookies();
        var result = {};
        result.utm_campaign = typeof parsed.searchObject.utm_campaign !== 'undefined' ? parsed.searchObject.utm_campaign : "";
        result.utm_medium = typeof parsed.searchObject.utm_medium !== 'undefined' ? parsed.searchObject.utm_medium : "";
        result.utm_source = typeof parsed.searchObject.utm_source !== 'undefined' ? parsed.searchObject.utm_source : "";

        if( result.utm_campaign === "" ){
            // Get utm parameters from cookie
            var cookieData = {};
            if( ( cookieData = cookies.get('__utmz') ) === false ){
                cookieData = cookies.get('utmztrack');
            }

            if( cookieData !== false ){
                cookieData = this.parseUtmCookie( cookieData );
                result.utm_source = cookieData.utmcsr;
                result.utm_medium = cookieData.utmcmd;
                result.utm_campaign = cookieData.utmccn;
            }
        }

        return result;
    }
}


// WEBPACK FOOTER //
// ../q-cars/src/utils/UtmHelper.js